import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from './constants';

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'common.imprint',
        page: lazyLoad(async () => {
            const { ImprintPage } = await import('./ImprintPage');

            return { default: ImprintPage };
        }),
        path: route.patterns.imprint,
    },
];
